<template lang="pug">
    v-navigation-drawer(fixed app
        :mini-variant='mini && !isShowingDrawer'
        v-model='drawer'
        @mouseover.native='mini = false' @mouseout.native='mini = true'
        clipped width='250'
        @transitionend="toggleDraw"
        )
        v-list(dense)
            //- PermitModal(v-if="dataUsers.group_level.includes('PIC')" imId="menu")
            template(v-for="(item, index) in items")
                v-list-item(active-class='secondary--text' :key="item.text" :to="item.link" @click='' v-if="isAllowed(item) && item.text != 'Dashboard Report'")
                    v-list-item-action
                        v-icon {{ item.icon }}
                    v-list-item-content
                        v-badge(v-if="item.badge" overlap color="yellow")
                            span(slot="badge" small style="color:black;") {{ item.badge }}
                            v-list-item-title {{ item.text }} &nbsp;&nbsp;&nbsp;&nbsp;
                        v-list-item-title(v-else) {{ item.text }}
            template(v-if="dataUsers.isAdmin" v-for="(menuAkses,index) in dataUsers.menuAkses" )
                v-list-item(v-if="menuAkses.iconName !== null && menuAkses.labelName !== null" active-class='secondary--text' :to="'/' + menuAkses.url" :key="index")
                    v-list-item-action
                        v-icon {{menuAkses.iconName}}
                    v-list-item-content
                        v-list-item-title {{menuAkses.labelName}}

           
</template>

<script>
import PermitModal from "@/components/PermitModal.vue";
import { mapGetters,mapMutations,mapState } from "vuex";
export default {
    name: "NavDrawer",
    props: {
    },
    components: {
        PermitModal
    },
    data: () => ({
        items: [
            { icon: 'library_add', text: 'Create New', link: '/menu-list', allowedUserType:['PIC'] },
            { icon: 'library_books', text: 'My Permit', link: '/my-permit', allowedUserType:['PIC'] },
            { icon: 'insert_drive_file', text: 'Lampiran Pengawalan', link: '/my-attachment', allowedUserType:['PIC'] },
            { icon: 'library_add_check', text: 'My Approval List', link: '/my-approval-list', allowedUserType:['WASKAT','SuptDIC','DIC','PJO','Manager', 'PNC', 'WKTT', 'KTT', 'Mining Manager', 'Nahkoda', 'SECHEAD', 'CUSTODIAN', 'SAFETYMITRA', 'SAFETYINTERNAL', 'DIVHEAD', 'CUSTODIANDIVHEAD', 'TEAMLEADER', 'DIVHEADHSE'] },
            { icon: 'insert_drive_file', text: 'My Attachment Approval List', link: '/my-attachment-approval-list', allowedUserType:['PIC','SuptDIC','DIC','PJO','Manager', 'PNC', 'WKTT', 'KTT', 'Mining Manager', 'Nahkoda', 'SECHEAD', 'CUSTODIAN', 'SAFETYMITRA', 'SAFETYINTERNAL', 'DIVHEAD', 'CUSTODIANDIVHEAD', 'TEAMLEADER', 'DIVHEADHSE'] },
            { icon: 'print', text: 'Cetak E-Waskat', link: '/print/ewaskat', allowedUserType:['PIC'], strictMitra: {groupLevel: ['PIC']} },
            { icon: 'mdi-progress-clock', text: 'Perpanjang E-Waskat', link: '/ewaskat/extend', allowedUserType:['PIC','SuptDIC','DIC','PJO','Manager', 'PNC', 'WKTT', 'KTT', 'Mining Manager', 'Nahkoda', 'SECHEAD', 'CUSTODIAN', 'SAFETYMITRA', 'SAFETYINTERNAL', 'DIVHEAD', 'CUSTODIANDIVHEAD', 'TEAMLEADER', 'DIVHEADHSE'], strictMitra: {groupLevel: ['PIC']}},
            { icon: 'recent_actors', text: 'Info Cuti', link: '/info-cuti', allowedUserType:['all']},
            { icon: 'live_help', text: 'FAQ', link: '/faq', allowedUserType:['all']}
        ],
        drawer: true,
        mini: true,
        dialog: false,
        izin: ''
    }),
    mounted() {
    },
    computed: {
        ...mapGetters(["isShowingDrawer", "showTheDrawer"]),
        ...mapState(['dataUsers']),
        ...mapMutations(['toggleDrawer']),
    },
    watch:{
        $route() {
            this.izin = '';
        },
        showTheDrawer() {
            this.drawer = this.showTheDrawer;
        }
    },
    methods: {
        toggleDraw: function (){
            if(!this.drawer && this.showTheDrawer) {
                this.$store.commit('toggleDrawer');
            }
        },
        isAllowed: function(item) {
            const list = item.allowedUserType || [];
            const userLevel = this.dataUsers.group_level;
            for (const level of userLevel) {
                if ('strictMitra' in item && this.dataUsers.location[0] === 'MITRA') {
                    if (this.dataUsers.group_level.some(gl => item.strictMitra.groupLevel.includes(gl))) {
                        return true;
                    }
                    return false;
                }
                
                if (list.includes(level) || list.includes('all')) return true;
            }
            return false;
        },
    },
};
</script>

<style>
</style>